import React from 'react';
import PropTypes from 'prop-types';

import SideMenu from '../sideMenu/SideMenu';
import Button from '../button/Button';
import ChannelDropdown from '../../containers/channelUtils/ChannelDropdown';
import SearchBarContainer from '../../containers/searchBarContainer/SearchBarContainer';
import {FormattedMessage} from 'react-intl';
import ChannelLink from '../../containers/channelUtils/ChannelLink';

export default function HeaderSideMenu({isOpen, onStateChange, items, onContactClick, searchValue}) {
  const closeMenu = () => onStateChange(false);

  return (
    <SideMenu isOpen={isOpen} onStateChange={onStateChange} searchValue={searchValue}>
      <div className="side-menu__wrap">
        <div className="side-menu__search">
          <SearchBarContainer
            manual
            onSearch={() => onStateChange(false)}
          />
        </div>

        <div className="side-menu__nav">
          <ChannelLink
            to="/profile"
            className="side-menu__link"
            onClick={closeMenu}
          >
            <FormattedMessage id="section.profile.title"/>
          </ChannelLink>
          {items.map(({name, to}, idx) => (
            <ChannelLink
              key={idx}
              className="side-menu__link"
              to={to}
              onClick={closeMenu}
            >
              <FormattedMessage id={name}/>
            </ChannelLink>
          ))}
        </div>

        <div className="side-menu__support">
          <Button onClick={onContactClick} filled>
            <FormattedMessage id="section.generic.contact-support"/>
          </Button>
        </div>

        <div className="side-menu__channel">
          <ChannelDropdown onChannelSelected={closeMenu}/>
        </div>
      </div>
    </SideMenu>
  );
}



// WEBPACK FOOTER //
// ./components/header/HeaderSideMenu.js